import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileMenu from "./MobileMenu";
import LanguageSelector from "./LanguageSelector";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";
import { contactConfig } from "../../config/contact";

function HeaderOne() {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/*============================== Header Area ==============================*/}
      <header className="th-header header-layout1">
        <div className="header-top">
          <div className="container th-container">
            <div className="row justify-content-center justify-content-xl-between align-items-center">
              <div className="col-auto d-none d-md-block">
                <div className="header-links">
                  <ul>
                    <li className="d-none d-xl-inline-block">
                      <i className="fa-sharp fa-regular fa-location-dot" />
                      <span>{contactConfig.address.line1}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto d-none d-xl-block">
                <div className="header-right">
                  <LanguageSelector />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
          {/* Main Menu Area */}
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to={getLocalizedPath("/")}>
                      <img
                        src="/assets/img/logo-haseki.png"
                        alt="Haseki Sultan Kız Yurdu"
                        className="img-fluid"
                        style={{ maxWidth: "280px", height: "auto" }}
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-auto me-xl-auto">
                  <nav className="main-menu d-none d-xl-inline-block">
                    <ul>
                      <li>
                        <Link to={getLocalizedPath("/")} className="active">
                          {t("nav.home")}
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link to={getLocalizedPath("/service")}>
                          {t("nav.services")}
                        </Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to={getLocalizedPath("/service/single-room")}>
                              {t("nav.singleRoom")}
                            </Link>
                          </li>
                          <li>
                            <Link to={getLocalizedPath("/service/double-room")}>
                              {t("nav.doubleRoom")}
                            </Link>
                          </li>
                          <li>
                            <Link to={getLocalizedPath("/service/triple-room")}>
                              {t("nav.tripleRoom")}
                            </Link>
                          </li>
                          <li>
                            <Link to={getLocalizedPath("/service/quad-room")}>
                              {t("nav.quadRoom")}
                            </Link>
                          </li>
                          <li>
                            <Link to={getLocalizedPath("/service/six-room")}>
                              {t("nav.sixRoom")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={getLocalizedPath("/service/social-areas")}
                            >
                              {t("nav.socialAreas")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={getLocalizedPath("/service/transportation")}
                            >
                              {t("nav.transportation")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={getLocalizedPath("/service/nearby-places")}
                            >
                              {t("nav.nearbyPlaces")}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={getLocalizedPath(
                                "/service/nearby-universities"
                              )}
                            >
                              {t("nav.nearbyUniversities")}
                            </Link>
                          </li>
                          <li>
                            <Link to={getLocalizedPath("/gallery")}>
                              {t("nav.generalPhotos")}
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to={getLocalizedPath("/contact")}>
                          {t("nav.onlineRegistration")}
                        </Link>
                      </li>
                      <li>
                        <Link to={getLocalizedPath("/about")}>
                          {t("nav.about")}
                        </Link>
                      </li>
                      <li>
                        <Link to={getLocalizedPath("/contact")}>
                          {t("nav.contact")}
                        </Link>
                      </li>
                    </ul>
                  </nav>
                  <div className="d-flex align-items-center gap-3 d-xl-none">
                    <LanguageSelector />
                    <button
                      type="button"
                      className="th-menu-toggle bg-transparent"
                      onClick={() => setIsMobileMenuOpen(true)}
                    >
                      <i className="far fa-bars" />
                    </button>
                  </div>
                </div>
                <div className="col-auto d-none d-xl-block">
                  <div className="header-button">
                    <Link
                      to={getLocalizedPath("/contact")}
                      className="th-btn style3 th-icon"
                    >
                      {t("nav.onlineRegistration")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* <div
              className="logo-bg bg-mask"
              style={{
                WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                maskImage: "url(/assets/img/logo_bg_mask.png)",
              }}
            /> */}
          </div>
        </div>
      </header>
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
    </>
  );
}

export default HeaderOne;
